import classNames from "classnames/bind";
import React from "react";
import { Button } from "../../Button";
import { DropdownMenu } from "../../DropdownMenu";
import { IconLoading } from "../../Icon";
import { Skeleton } from "../../Skeleton";
import { colours } from "../../constants/colours";
import type { ButtonProps } from "../../Button";
import type { DropdownMenuProps } from "../../DropdownMenu/types";
import styles from "./ListCard.module.scss";

const cx = classNames.bind(styles);

type ListCardActionsMenuProps = {
  actions?: DropdownMenuProps["options"];
  action?: ButtonProps;
  isBusy?: boolean;
  isLoading?: boolean;
  isActionsPinnedVisible: boolean;
  isMenuOpen: boolean;
  isMenuOpenControlled: boolean;
  menuContentProps?: DropdownMenuProps["contentProps"];
  onMenuOpenChange: (isOpen: boolean) => void;
  triggerRef: React.RefObject<HTMLButtonElement>;
};

/**
 * Hover-reveal actions control for `ListCard` rows.
 */
export const ListCardActionsMenu = ({
  actions,
  action,
  isBusy = false,
  isLoading = false,
  isActionsPinnedVisible,
  isMenuOpen,
  isMenuOpenControlled,
  menuContentProps,
  onMenuOpenChange,
  triggerRef,
}: ListCardActionsMenuProps) => (
  <Skeleton
    isLoading={isLoading}
    isBusy={isBusy}
  >
    <div
      className={cx(
        "actions",
        isActionsPinnedVisible && "actions--pinned-visible",
        isBusy && "is-busy-icon-container"
      )}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {isBusy ? (
        <IconLoading
          speed="fast"
          colour={colours.surface["300"]}
          size={24}
        />
      ) : actions ? (
        <DropdownMenu
          options={actions}
          rootProps={{
            ...(isMenuOpenControlled ? { open: isMenuOpen } : {}),
            onOpenChange: onMenuOpenChange,
          }}
          contentProps={menuContentProps}
        >
          <Button
            ref={triggerRef}
            variant="outline"
            icon="dots-three-vertical"
            size="xx-small"
          />
        </DropdownMenu>
      ) : action ? (
        <Button
          {...action}
          size="xx-small"
        />
      ) : null}
    </div>
  </Skeleton>
);
